import React from 'react';
import './Rules.css'; // If you want to use specific styles for this tab
import underconstruction from './underconstruction.jpg'; // Import the image

const Rules = () => {
    return (
        <div className="Rules">
            <h1>Rules Page</h1>
            {/* You can add more content here, tables, charts, anything you need for your Rules page */}
            <p>This is where the content for the Rules page goes.</p>
            <img src={underconstruction} className="under-construction" alt="Page Under Construction" /> {/* Use the image here */}
        </div>
    );
};

export default Rules;